/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Status_QueuedInputs */

const en_tasks_status_queued = /** @type {(inputs: Tasks_Status_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queued`)
};

const fr_tasks_status_queued = /** @type {(inputs: Tasks_Status_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En file`)
};

const ms_sg2_tasks_status_queued = /** @type {(inputs: Tasks_Status_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beratur`)
};

/**
* | output |
* | --- |
* | "Queued" |
*
* @param {Tasks_Status_QueuedInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_status_queued = /** @type {((inputs?: Tasks_Status_QueuedInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Status_QueuedInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_status_queued(inputs)
	if (locale === "fr") return fr_tasks_status_queued(inputs)
	return ms_sg2_tasks_status_queued(inputs)
});